export default async function getReviews(count) {
    const url = '/reviews.json';

    let json;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        json = await response.json();
    } catch (error) {
        return [
            {
                id: 0,
                text: ''
            }
        ];
    }

    // Filter for only 5-star reviews
    const fiveStarReviews = json.filter((review) => review.stars === 5);

    if (count > fiveStarReviews.length) {
        throw new Error(
            'Number of items requested exceeds the available 5-star reviews'
        );
    }

    const shuffledJson = fiveStarReviews.sort(() => 0.5 - Math.random());
    return shuffledJson.slice(0, count);
}
